module.exports = __webpack_public_path__ + "img/40_69_003_940.3fd4f48e.jpg";